import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import { AnimatePresence } from 'framer-motion';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { withContainer } from 'core/cache';
import ModalContainer from './modalContainer';

import toastifyStyles from '../styles/toastify.module.scss';

const NotificationsContainer = createReactClass({
  propTypes: {
    notifications: PropTypes.shape({
      data: PropTypes.shape({
        modals: PropTypes.arrayOf(PropTypes.shape({
          actions: PropTypes.arrayOf(PropTypes.shape({})),
          commitAction: PropTypes.func,
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          shouldModalCloseOnNavigation: PropTypes.bool,
        })),
      }),
      set: PropTypes.func,
    }).isRequired,
  },

  render() {
    const { modals } = this.props.notifications.data;

    return (
      <>
        <AnimatePresence>
          {modals.map(modal => <ModalContainer key={modal.id} modal={modal} />)}
        </AnimatePresence>
        <ToastContainer
          bodyClassName={toastifyStyles.body}
          className={toastifyStyles.container}
          closeButton={false}
          closeOnClick={false}
          hideProgressBar
          icon={false}
          autoClose={3000}
          pauseOnFocusLoss={false}
          draggable={false}
          toastClassName={toastifyStyles.element}
        />
      </>
    );
  },
});

export default withContainer(NotificationsContainer, {
  cache: {
    notifications: {
      initialData: {
        modals: [],
      },
    },
    notificationsModalsById: {
      initialData: {},
    },
  },
});
